import React, { useContext, useEffect, useState } from "react";
import MessageComponent from "./components/MessageComponent";
import { getCurrentTime } from "../../utils/commonUtils";
import { CommonContext } from "../../hooks/CommonContext";
import ChatInputWithEmojis from "components/chats/components/ChatInputWithEmojis";

function PrivateChat() {
  const {
    socketRef,
    room_id,
    privateChatMessages,
    setPrivateChatMessages,
    participateIdToMessage,
    userOwnData,
  } = useContext(CommonContext);
  const [inputText, setInputText] = useState("");
  const [filterMessagesByParticipantId, setFilterMessagesByParticipantId] =
    useState([]);

  useEffect(() => {
    setFilterMessagesByParticipantId(
      privateChatMessages.filter(
        (items) => items.participantID === participateIdToMessage
      )
    );
  }, [participateIdToMessage, privateChatMessages]);

  function privateChatHandler() {
    if (inputText.trim() !== "") {
      const current_time = getCurrentTime();

      setPrivateChatMessages((preData) => [
        ...preData,
        {
          participantID: participateIdToMessage,
          username: userOwnData.username,
          isOwnMessage: true,
          message: inputText,
          time: "" + current_time,
        },
      ]);
      socketRef.current.emit("new_message", {
        message: inputText,
        username: userOwnData.username,
        room_id: room_id,
        participateId: participateIdToMessage,
        senderUserId: userOwnData.userId,
      });
      // Clear the input field after sending the message
      setInputText("");
    }
  }

  return (
    <React.Fragment>
      <div className="messages-chat-box p-4">
        {filterMessagesByParticipantId?.map((item, index) => {
          return (
            <MessageComponent
              key={item.message + item.time + item.username}
              userName={item.username}
              sentTime={item.time}
              textMessage={item.message}
              isOwnMessage={item.isOwnMessage}
            />
          );
        })}
      </div>

      <ChatInputWithEmojis
        inputText={inputText}
        setInputText={setInputText}
        onSendMessage={privateChatHandler}
      />
    </React.Fragment>
  );
}

export default PrivateChat;
